/**
 * ContactTagsManagerModal
 *
 * "Gerenciar tags do contato" (acionado pelo menu dos inboxes). É só a casca
 * drawer/modal em volta do TagCombobox — o mesmo combobox inline usado no card
 * do contato: filtra o catálogo enquanto digita e, se não existir, recomenda
 * "Criar 'X'", adicionando como chip e seguindo aberto para adicionar várias.
 *
 * Props: isOpen, onClose, contactPhone, contactName, colors, onChange,
 *        displayMode 'modal'|'drawer', zIndex
 */
import React from 'react';
import { X, Tag } from 'lucide-react';
import TagCombobox from './TagCombobox';

const ContactTagsManagerModal = ({
  isOpen, onClose, contactPhone, contactName, colors, onChange, displayMode = 'modal', zIndex = 1000,
}) => {
  if (!isOpen) return null;
  const isDrawer = displayMode === 'drawer';

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex,
        display: 'flex',
        alignItems: isDrawer ? 'stretch' : 'flex-start',
        justifyContent: isDrawer ? 'flex-end' : 'center',
        padding: isDrawer ? 0 : '20px',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: colors.bgPrimary,
          borderRadius: isDrawer ? 0 : 16,
          width: isDrawer ? 420 : '100%', maxWidth: isDrawer ? '100%' : 460,
          height: isDrawer ? '100%' : 'auto',
          boxShadow: isDrawer ? '-8px 0 32px rgba(0,0,0,0.25)' : '0 20px 60px rgba(0,0,0,0.3)',
          display: 'flex', flexDirection: 'column',
        }}
      >
        {/* Header */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '16px 20px', borderBottom: `1px solid ${colors.borderColor}`, flexShrink: 0,
        }}>
          <div>
            <h3 style={{
              margin: 0, fontSize: 16, fontWeight: 600, color: colors.textPrimary,
              display: 'flex', alignItems: 'center', gap: 8,
            }}>
              <Tag size={18} color={colors.accentPrimary} /> Tags do contato
            </h3>
            <p style={{ margin: '2px 0 0', fontSize: 12, color: colors.textSecondary }}>
              Para: {contactName || contactPhone}
            </p>
          </div>
          <button onClick={onClose} aria-label="Fechar" style={{
            background: 'none', border: 'none', cursor: 'pointer', color: colors.textSecondary,
            padding: 8, borderRadius: 8,
          }}>
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: '16px 20px' }}>
          <TagCombobox
            contactPhone={contactPhone}
            colors={colors}
            onChange={onChange}
            autoFocus
          />
          <p style={{ margin: '12px 2px 0', fontSize: 11, color: colors.textTertiary, lineHeight: 1.5 }}>
            Digite para filtrar; se a tag não existir, aparece a opção de criar. Enter adiciona; clique no “x” do chip para remover.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactTagsManagerModal;
